import {
  REFRESH_USER_BALANCE_START,
  REFRESH_USER_BALANCE_SUCCESS,
  REFRESH_USER_BALANCE_FAILED,
} from 'constants/action-types/user/refreshUserBalance';

export default (state, { type, payload }) => {
  switch (type) {
    case REFRESH_USER_BALANCE_START:
      return {
        ...state,
        refreshUserBalance: {
          ...state.refreshUserBalance,
          loading: true,
          error: null,
          message: null,
        },
      };
    case REFRESH_USER_BALANCE_SUCCESS:
      return {
        ...state,
        refreshUserBalance: {
          ...state.refreshUserBalance,
          message: payload.message,
          error: null,
          loading: false,
        },
      };
    case REFRESH_USER_BALANCE_FAILED:
      return {
        ...state,
        refreshUserBalance: {
          ...state.refreshUserBalance,
          loading: false,
          error: payload,
          message: null,
        },
      };
    default:
      return null;
  }
};
